import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bbe87a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "content" }, null, -1))
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    style: {"padding-top":"65px"},
    class: "center-container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, {
        class: "center-div",
        style: { background: '#fff', padding: '24px', margin: 0, minHeight: '720px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_breadcrumb, {
                separator: ">",
                style: {"margin":"0px 0px 20px 10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: '/admin/article' }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 文章管理 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode("内容编辑")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.article.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: _ctx.doc,
                layout: "vertical",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSave()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CheckCircleOutlined),
                          _createTextVNode(" 保存 ")
                        ]),
                        _: 1
                      }),
                      _createTextVNode("    "),
                      _createVNode(_component_a_spin, { spinning: _ctx.loading }, null, 8, ["spinning"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: _ctx.doc.summary,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.doc.summary) = $event)),
                        placeholder: "文章摘要",
                        allowClear: true,
                        "auto-size": { minRows: 2, maxRows: 5 }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlePreviewContent()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EyeOutlined),
                          _createTextVNode(" 内容预览 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_drawer, {
            width: "900",
            placement: "right",
            closable: false,
            visible: _ctx.drawerVisible,
            onClose: _ctx.onDrawerClose
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "wangeditor",
                innerHTML: _ctx.previewHtml
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }, 8, ["visible", "onClose"]),
          _createVNode(_component_TheFooter)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}